import { RequiredTranslationsTemplate } from '.'

const es: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Español',
  },
  home: {
    title: 'AVISO DE PRODUCTO - ROCKRIDER XC500S',
    description:
      'Gracias por comprar una bicicleta de montaña (MTB) ROCKRIDER XC500S. Hemos detectado un posible punto débil en la horquilla delantera. Este defecto solo afecta a algunas bicicletas. Te rogamos que introduzcas los 30 dígitos del número de trazabilidad de tu bicicleta, para comprobar si está afectada por este aviso de producto:',
    form: {
      title: 'Por favor, indica los datos siguientes: ',
      fields: {
        serialNumber: 'Número de trazabilidad de la bicicleta',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Nombre',
        lastName: 'Apellidos',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        country: 'País',
        submit: 'Validar',
        choose: 'Elija...',
      },
      errors: {
        requiredField: 'Este campo es obligatorio',
        unknownSerialNumber: 'Número de serie desconocido',
        provide6Numbers: 'Tenga en cuenta que se requieren 6 dígitos',
      },
      confirmations: {
        good: {
          title: 'La bicicleta no está afectada por el defecto',
          p1: 'Te informamos de que tu bicicleta no está afectada por este aviso de producto. Puedes seguir disfrutando normalmente de ella.',
          p2: 'Te pedimos disculpas por cualquier inconveniente que te hayamos podido causar.',
          p3: 'Un cordial saludo,',
          p4: 'El equipo de Decathlon',
        },
        defective: {
          title: 'Lamentablemente, tu bicicleta está afectada por este defecto.',
          p1: 'Te pedimos que dejes de usar inmediatamente esta bicicleta y que contactes con la tienda Decathlon más cercana, para que te cambien la horquilla.',
          p2: 'Por favor, ten en cuenta que no podrás usar la bicicleta en varios días, durante la reparación. De todos modos, puedes estar seguro de que haremos todo lo posible para minimizar ese plazo. Te aconsejamos que consultes directamente al taller de la tienda Decathlon que hayas elegido, para tener una estimación del plazo de reparación.',
          p3: 'Para encontrar el Taller Decathlon más cercano a tu domicilio:',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'Más abajo encontrarás el "Documento de devolución del cliente" que debes presentar a nuestro técnico cuando acudas al taller:',
          p5: 'Para más información, contacta con nuestro centro de atención al cliente específico para este producto, llamando al teléfono 0 805 38 38 49, que es gratuito si se llama desde el territorio de Francia metropolitana (está disponible de lunes a viernes de las 9:00 a las 19:00 horas), o escribiendo un correo electrónico a la dirección rappel.decathlon@fandi.fr.',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Dónde encontrar el número de trazabilidad de la bicicleta:',
      description:
        'El número de 30 dígitos está impreso en la parte inferior del cuadro de la bicicleta, cerca de la caja del pedalier y de los pedales. Ver la imagen siguiente.',
    },
  },
}

export default es
